// types
import { TourConfig, UserRole } from '../../../@types';
import { userRolesWbg } from '../../../@types/unions';

// i18n
import { TFunction } from 'i18next';

// mui
import { Grid, Typography } from '@mui/material';

// dialogs
import { DialogArticle } from '../../dialogs/DialogArticle/DialogArticle';

// utils
import { getArticles } from '../../../utils/articles';

// props
export interface GetTourConfigsParams {
	t: TFunction;
}

export const getTourConfigs = ({ t }: GetTourConfigsParams): TourConfig[] => {
	// vars
	const rolesAll: UserRole[] = ['FNFA', 'GENERAL', 'LIAISON', 'STAFF', 'TTL', 'WFA'];

	return [
		{
			isActive: true,
			isImmediate: true,
			name: 'IFR',
			roles: rolesAll,
			route: '/projects',
			steps: [
				{
					dialogId: 'articleIfr',
					render: ({ isOpen, onClose }) => {
						const article = getArticles({ id: 'r380', t })[0];
						return (
							<DialogArticle article={article} hasClose={true} isOpen={isOpen} onClose={onClose} />
						);
					},
					type: 'DIALOG',
				},
			],
		},
		{
			isActive: true,
			isImmediate: true,
			name: 'R3110',
			roles: rolesAll,
			route: '/projects',
			steps: [
				{
					dialogId: 'articleR3110',
					render: ({ isOpen, onClose }) => {
						const article = getArticles({ id: 'r3110', t })[0];
						return (
							<DialogArticle article={article} hasClose={true} isOpen={isOpen} onClose={onClose} />
						);
					},
					type: 'DIALOG',
				},
			],
		},
		{
			isActive: true,
			isImmediate: true,
			name: 'IFR_REPORTS_TAB',
			roles: [...userRolesWbg],
			route: '/project/',
			steps: [
				{
					PopoverProps: {
						actions: [
							{
								children: t('gotIt'),
								color: 'primary',
								size: 'small',
								variant: 'contained',
							},
						],
						PopoverProps: {
							transformOrigin: {
								horizontal: 'center',
								vertical: 'top',
							},
						},
					},
					render: () => {
						return (
							<Grid container spacing={1}>
								<Grid item xs={12}>
									<Typography color="brand.blue.400" fontWeight={600}>
										{t('tours.ifrReportsTab.1.title')}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									{t('tours.ifrReportsTab.1.description')}
								</Grid>
							</Grid>
						);
					},
					target: 'reports',
					type: 'POPOVER',
				},
			],
		},
		{
			isActive: true,
			isImmediate: true,
			name: 'INFLOW',
			roles: [...userRolesWbg],
			route: '/project/{param}/transactions',
			steps: [
				{
					PopoverProps: {
						actions: [
							{
								children: t('gotIt'),
								color: 'primary',
								size: 'small',
								variant: 'contained',
							},
						],
						PopoverProps: {
							transformOrigin: {
								horizontal: 'center',
								vertical: 'top',
							},
						},
					},
					render: () => {
						return (
							<Grid container spacing={1}>
								<Grid item xs={12}>
									<Typography color="brand.blue.400" fontWeight={600}>
										{t('tours.inflow.1.title')}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									{t('tours.inflow.1.description')}
								</Grid>
							</Grid>
						);
					},
					target: 'selectTransactionPage',
					type: 'POPOVER',
				},
			],
		},
		{
			isActive: true,
			isImmediate: true,
			name: 'SUBMIT_FEEDBACK_LOCATION',
			roles: rolesAll,
			route: '/projects',
			steps: [
				{
					PopoverProps: {
						actions: [
							{
								children: t('gotIt'),
								color: 'primary',
								size: 'small',
								variant: 'contained',
							},
						],
					},
					render: () => {
						return (
							<Grid container spacing={1}>
								<Grid item xs={12}>
									<Typography color="brand.blue.400" fontWeight={600}>
										{t('tours.submitFeedbackLocation.1.title')}
									</Typography>
								</Grid>
								<Grid item xs={12}>
									{t('tours.submitFeedbackLocation.1.description')}
								</Grid>
							</Grid>
						);
					},
					target: 'getHelp',
					type: 'POPOVER',
				},
			],
		},
	];
};
